import IframeResizer from "iframe-resizer-react"
import React from "react"

export const Order = ({ productID, name }) => {
  const onMessage = (data) => {
    window.dataLayer.push(data.message.gtm)
  }

  return (
    <div className="container">
      <div className="columns is-centered">
        <div className="column">
          <IframeResizer
            checkOrigin={true}
            onMessage={onMessage}
            title={name || "B_I Produkte bestellen"}
            src={`https://order.bi-medien.de/${productID}`}
            frameBorder="0"
            width="100%"
          />
        </div>
      </div>
    </div>
  )
}
